<template>
<!--  分账账号列表-->
  <div v-if="!showModal">
    <a-spin :spinning="loading">
      <a-form ref="formRef" :model="formState" name="form" @finish="onSearch">
        <a-row>

          <a-form-item class="ui-form__item" label="账号名称" name="accountName">
            <a-input placeholder="请输入" v-model:value="formState.accountName"></a-input>
          </a-form-item>

          <a-form-item class="ui-form__item" label="渠道类型" name="channelType">
            <a-select placeholder="请选择" v-model:value="formState.channelType" style="width: 180px;">
              <a-select-option :value="''">全部</a-select-option>
              <a-select-option :value="'HUIFU'">汇付</a-select-option>
              <a-select-option :value="'ALLINPAY'">通联</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item class="ui-form__item" label="默认账号" name="isDefault">
            <a-select placeholder="请选择" v-model:value="formState.isDefault" style="width: 180px;">
              <a-select-option value="1">是</a-select-option>
              <a-select-option value="0">否</a-select-option>
            </a-select>
          </a-form-item>

        </a-row>

        <a-row>
          <a-col :span="18">
            <a-button v-permission="['ledger_manage_account_add']" type="primary" @click="onAdd">新增</a-button>
            <a style="margin-left: 10px;" @click="onTipShow">
              默认账号说明
            </a>
          </a-col>
          <a-col :span="6" style="text-align: right;">
            <a-button style="margin-right: 10px" type="primary" html-type="submit">搜索</a-button>
            <a-button @click="onReset">重置</a-button>
          </a-col>
        </a-row>
      </a-form>

      <div style="margin-top: 20px;">
        <a-table :pagination="pagination" rowKey="id" :columns="columns" :dataSource="list" tableLayout="auto" :scroll="{x: 1300}">
          <template #bodyCell="{ column, record, index }">

            <template v-if="column.key === 'channelType'">
              <div>{{transChannelType(record.channelType)}}</div>
            </template>

            <template v-if="column.key === 'isDefault'">
              <div v-if="record.isDefault">是</div>
              <div v-else>否</div>
            </template>

            <template v-if="column.key === 'createTime'">
              {{ transDateTime(record.createTime) }}
            </template>

            <template v-if="column.key === 'action'">
              <a-dropdown :trigger="['click', 'hover']">
                <a-button @click.prevent>操作 <Icon icon="DownOutlined"></Icon>
                </a-button>
                <template #overlay>
                  <a-menu>
                    <div>
                      <a-menu-item @click="onSetDefaultAccount(record)" v-if="!record.isDefault">
                        设置默认账号
                      </a-menu-item>
                      <a-menu-item @click="onResetAccount(record)" v-if="record.isDefault">
                        移除默认账号
                      </a-menu-item>
                      <a-menu-item @click="onEditAccount(record)" v-if="false && record.channelType == 'ALLINPAY'">
                        编辑
                      </a-menu-item>
                      <a-menu-item @click="onDelete(record)" v-if="record.channelType == 'ALLINPAY'">
                        删除
                      </a-menu-item>
                    </div>
                  </a-menu>
                </template>
              </a-dropdown>
            </template>
          </template>
        </a-table>
      </div>
    </a-spin>
  </div>
  <temp v-else :isEdit="isEdit" :isDetail="isDetail" :id="id" @back="onBack"></temp>
</template>

<script>
  import {
    Icon
  } from '@/components/icon/icon.js';
  import {
    paymentAccountList,
    savePaymentAccount,
    setDefaultPaymentAccount,
    cinemaAccountList,
    setCinemaAccount,
    clearDefaultPaymentAccount,
    delPaymentAccount,
  } from '@/service/modules/ledger.js';
  import temp from './temp.vue';
  import { h } from 'vue';


  export default {
    components: {
      Icon,
      temp
    },
    data() {
      return {
        loading: false,
        formState: {},
        showModal: false,
        list: [],
        columns: [{
          title: '渠道类型',
          dataIndex: 'channelType',
          key: 'channelType'
        }, {
          title: '账号名称',
          dataIndex: 'accountName',
          key: 'accountName'
        }, {
          title: '账号编号',
          dataIndex: 'accountNo',
          key: 'accountNo'
        }, {
          title: '备注',
          dataIndex: 'remark',
          key: 'remark'
        }, {
          title: 'appId',
          dataIndex: 'appId',
          key: 'appId'
        }, {
          title: 'prod模式API_KEY',
          dataIndex: 'prodApiKey',
          key: 'prodApiKey'
        }, {
          title: '是否默认分账账号',
          key: 'isDefault'
        }, {
          title: '创建时间',
          key: 'createTime',
          width: 180
        }, {
            title: '操作',
            key: 'action'
        },],
        pagination: {
          showSizeChanger: true,
          showQuickJumper: true,
          size: "middle",
          showTotal: (total) => {
            return "共 " + total + " 条";
          },
          total: 0,
          current: 1,
          pageSize: 10,
          onChange: (page) => {
            this.pagination.current = page;
            this.getData();
          },
          onShowSizeChange: (page, pageSize) => {
            this.pagination.current = 1;
            this.pagination.pageSize = pageSize;
            this.getData();
          }
        },
        isEdit: false,
        isDetail: false,
        id: 0,
        searchData: [],
        visibleEdit: false,
        formEdit: {},
        bankCodeData: [],
        provCodeData: [],
        areaCodeData: [],
      }
    },
    created(){
      this.getData();
    },
    methods: {
      onBack() {
        this.showModal = false;
        this.getData();
      },
      onSearch() {
        this.pagination.current = 1;
        // //this.pagination.pageSize = 10;
        this.searchData = JSON.parse(JSON.stringify(this.formState));
        this.getData();
      },
      onReset() {
        this.$refs.formRef.resetFields();
        this.onSearch();
      },
      async getData() {
        const postData = {
          page: this.pagination.current,
          pageSize: this.pagination.pageSize,
          ...this.searchData,
        }
        this.loading = true;
        try{
          let res = await paymentAccountList(postData);
          if(res.code == 200){
            this.loading = false;
            this.list = res.data.list;
            this.pagination.total = res.data.totalCount;
          }
        }catch(e){
          this.loading = false;
        }
      },
      onAdd() {
        this.id = 0;
        this.isEdit = false;
        this.showModal = true;
        this.isDetail = false;
      },
      onEdit(val) {
        if (val.type == 1) {
          // 个人
          let provValue;
          this.bankCodeData = bankCode;
          this.provCodeData = provCode;
          this.list.forEach(item=>{
            if(item.id == val.id){
              this.formEdit = item;
              provValue = item.provCode;
            }
          })
          provCode.forEach(item=>{
            if(item.value == provValue){
              this.areaCodeData = item.cities;
            }
          })
          this.visibleEdit = true;
        } else {
          // 企业
          this.$message.warn('企业账户不能编辑，未通过审核的账户请执行删除操作');
          // this.id = val.id;
          // this.isEdit = true;
          // this.isDetail = false;
          // this.showModal = true;
        }

      },
      async onUpdateState(val) {
        await updateState({
          id: val.id,
        });
        this.onSearch();
      },
      onDetail(val){
        this.id = val.id;
        this.isEdit = false;
        this.isDetail = true;
        this.showModal = true;
      },
      async onSetDefaultAccount(item) {
        this.$confirm({
          content: '设置账号为默认分账账号',
          onOk: async () => {
            const ret = await setDefaultPaymentAccount({
              id: item.id
            });
            if (ret.code == 200) {
              this.$message.success('设置成功');
              this.getData();
            }
          }
        })

      },
      onResetAccount(item) {
        this.$confirm({
          title: '提示',
          content: '确定移除默认账号?',
          onOk: async () => {
            this.loading = true;
            const ret = await clearDefaultPaymentAccount({
              id: item.id
            });
            if (ret.code == 200) {
              this.$message.success('设置成功, 当前默认账号为系统分账账号');
              this.getData();
            }
            this.loading = false;
          }
        })
      },
      onDisabled(val){
        let text = val.disabled == 'Y' ? '启用' : '禁用';
        this.$confirm({
          title: 'warning',
          content: '正在进行' + text + '操作',
          okText: '确定',
          cancleText: '取消',
          onOk: ()=>{
            if(val.disabled == 'N'){
              this.disableUser(val.id);
            }else{
              this.enableUser(val.id);
            }
          }
        })
      },
      transChannelType(type){
        const typeObj = {
          'HUIFU': '汇付',
          'ALLINPAY': '通联',
        }
        return typeObj[type];
      },
      async disableUser(id){
        let res = await disabledLedger({id});
        if(res.code == 200){
          this.getData();
          this.$message.success('禁用成功');
        }
      },
      async enableUser(id){
        let res = await enableLedger({id});
        if(res.code == 200){
          this.getData();
          this.$message.success('启用成功');
        }
      },
      onChooseBank(value){
        this.formEdit.bankCode = value;
      },
      selectInput(inputValue, option){
        return (
          option.label.indexOf(inputValue.toLowerCase()) >= 0
        );
      },
      onCancel() {
        this.visibleEdit = false;
        this.$refs.form.resetFields();
      },
      onSubmit() {
        this.$refs.form.validateFields().then(async () => {
          const postData = {
            adapayMemberId : this.formEdit.id,
            memberId : this.formEdit.memberId,
            bankAcctType : this.formEdit.type == 1 ? 2 : 1,//1-对公；2-对私
            cardId: this.formEdit.cardId,
            cardName: this.formEdit.cardName,
            telNo: this.formEdit.telNo,
            bankCode: this.formEdit.bankCode,
            provCode: this.formEdit.provCode,
            areaCode: this.formEdit.areaCode
          };
          if(this.formEdit.type == 1){
            postData.certId = this.formEdit.certId;
          }
          let res = await updateLedger(postData);
          if(res.code == 200){
            this.$message.success('修改成功');
            this.visibleEdit = false;
          }
        })
      },
      onDelete(val){
        this.$confirm({
          title: '提示',
          content: '是否删除账户',
          onOk: () => {
            this.loading = true;
            delPaymentAccount({ id: val.id }).then(res=>{
              this.loading = false;
              if (res.code == 200) {
                this.getData();
                this.$message.success('删除成功');
              }
            }).catch(err=>{
              this.$message.error('删除失败');
              this.loading = false;
            });
          }
        })
      },
      async deleteLedger(id){
        // let res = await deleteLedger({ id });
        // if(res.code == 200){
        // 	this.getData();
        // 	this.$message.success('删除成功');
        // }
      },
      onChooseProvince(value,obj){
        this.formEdit.areaCode = '';
        this.areaCodeData = [];
        this.formState.provCode = value;
        this.areaCodeData = obj.cities;
      },
      selectProvCode(inputValue, option){
        return (
          option.label.indexOf(inputValue.toLowerCase()) >= 0
        );
      },
      onChooseArea(value,obj){
        this.formState.areaCode = value;
      },
      selectAreaCode(inputValue, option){
        return (
          option.label.indexOf(inputValue.toLowerCase()) >= 0
        );
      },
      onEditAccount() {},
      async onTipShow() {
        const postData = {
          page: 1,
          pageSize: 99,
        }
        this.loading = true;
        try{
          let res = await paymentAccountList(postData);
          if (res.code == 200) {
            this.loading = false;
            let defaultAccount;
            this.list.forEach((item)=>{
              if(item.isDefault) {
                defaultAccount = item;
              }
            });
            this.$confirm({
              title: '分账账号说明',
              content: () => h('div', [
                h('p', `当前默认账号：${defaultAccount? defaultAccount.accountName : '系统分账账号'}`),
                h('p', '账号类型分为：1.系统分账账号，2.分账列表中的账号。'),
                h('p', '在未配置默认分账账号时，会直接使用系统分账账号作为默认分账账号。'),
                h('p', '系统分账账号只有汇付，通联没有系统分账账号。'),
                h('p', '通联不涉及分账，不用配置分账组。'),
              ]),
              // h('p', { style: { color: '#ff4d4f' } }, '这是红色的第二行内容。'),
            })
          }
        }catch(e){
          this.loading = false;
        }

      },
    }
  }
</script>

<style>
  .ui-form__item {
    margin-right: 30px;
  }
</style>
